<template>
  <div id="page">
    <div class="cut">
      <vue-cropper
        ref="cropper"
        :img="option.img"
        :output-size="option.size"
        :output-type="option.outputType"
        :info="option.info"
        :full="option.full"
        :fixed="option.fixed"
        :fixed-number="option.fixedNumber"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :fixed-box="option.fixedBox"
        :original="option.original"
        :auto-crop="option.autoCrop"
        :auto-crop-width="option.autoCropWidth"
        :auto-crop-height="option.autoCropHeight"
        :center-box="option.centerBox"
        :canScale="option.canScale"
        :enlarge="option.enlarge"
        @real-time="realTime"
        :high="option.high"
        @img-load="imgLoad"
        mode="100%"
        :maxImgSize="option.max"
        style="background-image: none;"
      >
      </vue-cropper>
    </div>

    <div class="mt-3 actionGroup">
      <b-button @click="changeScale(1)" variant="danger">放大</b-button>
      <b-button @click="changeScale(-1)" variant="danger">缩小</b-button>
      <b-button @click="rotateLeft" variant="danger">左旋</b-button>
      <b-button @click="rotateRight" variant="danger">右旋</b-button>
    </div>
    <div class="mt-3 devDone">
      <b-button variant="primary" @click="cropImage()">完成</b-button>
    </div>

    <b-modal ok-only ref="model_tip" title="提示" ok-title="确定">
      <p class="my-4">截图框内不能留有空白，请放大或缩小图片</p>
    </b-modal>
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
  </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  name: "EditCardface_xy",
  data() {
    return {
      imgPath: "",
      bankSerialNumber: "",
      bankCode: "",
      selectParam: null,
      cardOri: "",
      cardTheme: "99",
      option: {
        img: "",
        size: 1,
        info: false,
        full: true,
        outputType: "png",
        canMove: true,
        fixedBox: true,
        original: false,
        canMoveBox: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 160,
        autoCropHeight: 150,
        centerBox: false,
        high: true,
        max: 2000,
        fixed: true,
        fixedNumber: [14, 9],
        canScale: true,
        enlarge: 1
      },
      initScale: "",
      errorMsg: "",
      targetImg: "",
      radio: "" //是否邮寄
    };
  },

  methods: {
    showErrorMsg: function() {
      this.$refs["model_error"].show();
    },
    handleOk: function(bvModalEvt) {},
    showCropTip: function() {
      this.$refs["model_tip"].show();
    },
    // 实时预览函数
    realTime(data) {
      console.log("realTime");
      let w = this.$refs.cropper.cropW;
      let h = this.$refs.cropper.cropH;
      // 图片缩放比例
      let scale = this.$refs.cropper.scale;
      // 图片偏移x轴
      let x = this.$refs.cropper.x;
      // 图片偏移y轴
      let y = this.$refs.cropper.y;
      // 图片真实宽度
      let trueWidth = this.$refs.cropper.trueWidth;
      // 图片真实高度
      let trueHeight = this.$refs.cropper.trueHeight;
      // 裁剪框的坐标轴
      let cropX = this.$refs.cropper.cropX;
      let cropY = this.$refs.cropper.cropY;

      console.log("截图框宽高：" + w + "*" + h);
      console.log("图片缩放比例：" + scale);
      console.log("图片偏移x轴：" + x);
      console.log("图片偏移y轴：" + y);
      console.log("图片真实宽度：" + trueWidth);
      console.log("图片真实高度：" + trueHeight);
      console.log("裁剪框的坐标轴：" + cropX + "*" + cropY);

      console.log(data);
    },
    imgLoad(msg) {
      console.log(msg);
      // 图片初始缩放比例
      let scale = this.$refs.cropper.scale;
      this.initScale = scale;
      let cropperObj = this.$refs.cropper;
      let maxWidth = cropperObj.w;
      let maxHeight = cropperObj.h;
      let imgW = cropperObj.trueWidth * cropperObj.scale;
      let imgH = cropperObj.trueHeight * cropperObj.scale;
      maxWidth = imgW < maxWidth ? imgW : maxWidth;
      maxHeight = imgH < maxHeight ? imgH : maxHeight;

      console.log("maxWidth:" + maxWidth);
      console.log("maxHeight:" + maxHeight);
      console.log("imgW:" + imgW);
      console.log("imgH:" + imgH);
      console.log("maxWidth:" + maxWidth);
      console.log("maxWidth:" + maxWidth);
      console.log("initScale:" + this.initScale);

      // if (this.cardOri == 0) {
      //   //横版
      //   this.option.autoCropWidth = maxWidth *0.8;
      //   this.option.autoCropHeight = maxWidth *0.8 * 9/16;
      //   console.log('autoCropWidth:' + this.option.autoCropWidth)
      //   console.log('autoCropHeight:' + this.option.autoCropHeight)
      //   this.option.fixedNumber = [16, 9];
      // } else if (this.cardOri == 1) {
      //   //竖版
      //   this.option.autoCropWidth = maxHeight *0.8 * 9/16;
      //   this.option.autoCropHeight = maxHeight *0.8;
      //   console.log('autoCropWidth:' + this.option.autoCropWidth)
      //   console.log('autoCropHeight:' + this.option.autoCropHeight)
      //   this.option.fixedNumber = [9, 16];
      // }

      if (this.cardOri == 0) {
        //横版
        this.option.autoCropWidth = maxWidth * 0.9;
        this.option.autoCropHeight = (maxWidth * 0.9 * 9) / 16;
        console.log("autoCropWidth:" + this.option.autoCropWidth);
        console.log("autoCropHeight:" + this.option.autoCropHeight);
        this.option.fixedNumber = [14, 9];
      } else if (this.cardOri == 1) {
        //竖版
        this.option.autoCropWidth = (maxHeight * 0.9 * 9) / 16;
        this.option.autoCropHeight = maxHeight * 0.9;
        console.log("autoCropWidth:" + this.option.autoCropWidth);
        console.log("autoCropHeight:" + this.option.autoCropHeight);
        this.option.fixedNumber = [9, 14];
      }
    },
    hasWhiteSpace: function() {
      let has = true;
      let axis = this.$refs.cropper.getImgAxis();
      let cropAxis = this.$refs.cropper.getCropAxis();

      console.log(axis);
      console.log(cropAxis);

      // 左边的横坐标 图片不能超过截图框
      if (axis.x1 >= cropAxis.x1) {
        has = false;
      }
      // 右边横坐标
      if (axis.x2 <= cropAxis.x2) {
        has = false;
      }
      // 纵坐标上面
      if (axis.y1 >= cropAxis.y1) {
        has = false;
      }
      // 纵坐标下面
      if (axis.y2 <= cropAxis.y2) {
        has = false;
      }
      return has;
    },
    cropImage: function() {
      // var canvas = this.cropper.getCroppedCanvas();
      // var dataURL = canvas.toDataURL('img/png', 0.3);
      // localStorage.setItem('destImg', dataURL);
      // this.toUploadCardface();

      var that = this;
      let has = that.hasWhiteSpace();
      if (!has) {
        that.showCropTip();
        return;
      }

      // 获取截图的blob数据
      this.$refs.cropper.getCropBlob(data => {
        // do something
        console.log(data);
        let url = window.URL.createObjectURL(data);
        this.targetImg = url;
        console.log("blob url:" + url);
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function() {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          image.onload = null; // 避免重复加载
          console.log("图片宽高:" + w + "*" + h);
          if (that.cardOri == 0) {
            //横版
            if (w >= 1024 && h >= 665) {
              that.toUploadCardface();
            } else {
              that.errorMsg =
                "剪裁后的图片像素不符合要求，剪裁后的图片像素：" + w + "*" + h;
              that.showErrorMsg();
            }
          } else if (that.cardOri == 1) {
            //竖版
            if (w >= 665 && h >= 1024) {
              that.toUploadCardface();
            } else {
              that.errorMsg =
                "剪裁后的图片像素不符合要求，剪裁后的图片像素：" + w + "*" + h;
              that.showErrorMsg();
            }
          }
        };
      });
    },
    toUploadCardface() {
      var selectParam = JSON.stringify(this.selectParam);
      let cardThemeParam = JSON.stringify(this.cardTheme);
      this.$router.replace({
        name: "UploadCardface_xy",
        params: {
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          selectParam: selectParam,
          cardOri: this.cardOri,
          cardTheme: cardThemeParam,
          targetImg: this.targetImg,
          radio: this.radio
        }
      });
      console.log("this.targetImg--->", this.targetImg);
    },
    refreshCrop() {
      // clear
      this.$refs.cropper.refresh();
    },
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    }
  },
  mounted: function() {
    this.imgPath = this.$route.params.imagePath;
    console.log("imgPath:" + this.imgPath);
    this.radio = this.$route.params.radio;
    console.log("radio:" + this.radio);
    this.option.img = this.imgPath;
    this.bankSerialNumber = this.$route.params.bankSerialNumber;
    console.log("bankSerialNumber:" + this.bankSerialNumber);

    this.bankCode = this.$route.params.bankCode;
    console.log("bankCode:" + this.bankCode);

    var selectParam = this.$route.params.selectParam;
    console.log("selectParam:" + selectParam);
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
    this.cardOri = this.$route.params.cardOri;
    console.log("cardOri:" + this.cardOri);

    // if (this.cardOri == 0) {
    //   //横版
    //   this.option.autoCropWidth = 331;
    //   this.option.autoCropHeight = 186;
    //   this.option.fixedNumber = [16, 9];
    // } else if (this.cardOri == 1) {
    //   //竖版
    //   this.option.autoCropWidth = 186;
    //   this.option.autoCropHeight = 331;
    //   this.option.fixedNumber = [9, 16];
    // }

    let themeParam = this.$route.params.cardTheme;
    console.log("themeParam:" + themeParam);
    if (themeParam !== undefined) {
      this.cardTheme = JSON.parse(themeParam);
    }

    //this.wxJsSdk();
  }
};
</script>

<style scoped>
.cut {
  width: 100vw;
  height: 80vh;
}

.test-button {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}

.actionGroup {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.devDone {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 16px;
}

/* .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c0ccda;
    color: #1f2d3d;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 20px 10px 0px 0px;
    padding: 9px 15px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #50bfff;
    border-color: #50bfff;
    transition: all .2s ease;
    text-decoration: none;
    user-select: none;
  } */
</style>



// WEBPACK FOOTER //
// src/components/xiangyang/EditCardface_xy.vue